import React from 'react'
import { object, func } from 'prop-types'

import { useRouter } from 'next/router'
import retrieveData from '@/lib/retrieve-data'

import SearchResults from '@/component/Composition/SearchResults'

import parseQsOptions from '@/lib/search-query-string-options-parser'
import createRenderSearchQuery from '@/query/search/render-search'

const SearchPage = ({ searchResults, qsOptions, __url }) => {
  const router = useRouter()
  const handleSearch = (term) => {
    router.push({
      pathname: __url('/search'),
      query: { ...qsOptions, q: term }
    })
  }
  const handleNextPage = () => {
    router.push({
      pathname: __url('/search'),
      query: { ...qsOptions, page: qsOptions.page + 1 }
    })
  }
  const handlePrevPage = () => {
    router.push({
      pathname: __url('/search'),
      query: { ...qsOptions, page: qsOptions.page - 1 }
    })
  }
  const getImages = (article) => {
    const getImage = (size) =>
      article.images?.[`thumbnail_16x9_${size}`]?.[0]?.url
    return {
      ...article,
      src: getImage(320),
      srcSet: [
        { width: 320, src: getImage(320) },
        { width: 448, src: getImage(448) },
        { width: 640, src: getImage(640) }
      ]
    }
  }

  return (
    <SearchResults
      onSearch={handleSearch}
      onNextPage={handleNextPage}
      onPrevPage={handlePrevPage}
      searchTerm={qsOptions.q}
      sortOption={qsOptions.sort}
      page={qsOptions.page}
      pageSize={searchResults.pageSize}
      results={searchResults.results.map(getImages)}
      total={searchResults.total}
    />
  )
}

SearchPage.propTypes = {
  searchResults: object,
  qsOptions: object,
  __url: func.isRequired
}

SearchPage.getInitialProps = async (context) => {
  const parsedQsOptions = parseQsOptions(context.query)
  const query = createRenderSearchQuery()
  const { data } = await retrieveData(context, query, {
    searchTerm: parsedQsOptions.q,
    sort: parsedQsOptions.sort,
    page: parsedQsOptions.page
  })
  return {
    instance: data.instance,
    searchResults: data.search,
    searchTerm: parsedQsOptions.q,
    qsOptions: parsedQsOptions
  }
}

export default SearchPage
